export default "__VITE_PUBLIC_ASSET__7962db5a__"